import { Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/Labor/LaborModel';
import { RootState } from '../../../store';
import LaborForm from '../LaborForm/LaborForm';

const LaborModal: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxLabor = useSelector((state: RootState) => state.models.labor);

  return (
    <Modal
      title={!!reduxLabor.id ? 'Modifica' : 'Adauga'}
      open={reduxLabor.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <LaborForm />
    </Modal>
  );
};

export default LaborModal;
